import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { config } from './../Config'

mapboxgl.accessToken = config.MapBoxAccessToken

export class MapBox {
    constructor() {
        this.center = [30, 15.5]

        // Use the Security Module Map Style URL as a default style for the map
        this.map = new mapboxgl.Map({
            container: 'map',
            style: config.SecurityModuleMapStyleURL,
            center: this.center,
            zoom: 2
        })
    }
}

const map = new MapBox()
export default map